<template>
  <!-- Featured Item -->
  <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
    <Slide v-for="item in Venue" :key="item.id">
      <div class="featured-venues-item">
        <div class="listing-item mb-0">
          <div class="listing-img">
            <router-link to="/coaches/venue-details">
              <img :src="require(`@/assets/img/venues/${item.Image}`)" alt="Venue" />
            </router-link>
            <div class="fav-item-venues">
              <span :class="item.Class">{{ item.Badge }}</span>
              <h5 class="tag tag-primary">{{ item.Price }}<span>/hr</span></h5>
            </div>
          </div>
          <div class="listing-content text-start">
            <div class="list-reviews">
              <div class="d-flex align-items-center">
                <span class="rating-bg">{{ item.Rateing }}</span
                ><span>{{ item.Reviews }}</span>
              </div>
              <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected(item)">
                <i class="feather-heart"></i>
              </a>
            </div>
            <h3 class="listing-title">
              <router-link to="/coaches/venue-details">{{ item.Title }}</router-link>
            </h3>
            <div class="listing-details-group">
              <p>{{ item.Content }}</p>
              <ul>
                <li>
                  <span> <i class="feather-map-pin"></i>{{ item.Location }} </span>
                </li>
                <li>
                  <span>
                    <i class="feather-calendar"></i>Next Availablity :
                    <span class="primary-text">{{ item.Day }}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="listing-button">
              <div class="listing-venue-owner">
                <a class="navigation">
                  <img
                    :src="require(`@/assets/img/profiles/${item.Avatar}`)"
                    alt="User"
                  />{{ item.Name }}
                </a>
              </div>
              <router-link to="/coaches/venue-details" class="user-book-now"
                ><span><i class="feather-calendar me-2"></i></span>Book Now</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <!-- /Featured Item -->
    </Slide>
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Venue from "@/assets/json/venue-details-carousel.json";
export default {
  data() {
    return {
      Venue: Venue,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
